// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3k0iL","label":"SetPasswdForm_label__1m3hg"};